module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0011.jpg?v=49a52237";